import { Map as ImmutableMap, List, Record } from 'immutable';

import { accountsTypes } from '../accounts';

export const ACCOUNT_DISCOVERY_REDUCER_KEY = 'upsertInstitutionLoginStore';

export const DIALOG_TYPE_ACCOUNTS_DISCOVERY = 'DIALOG_TYPE_ACCOUNTS_DISCOVERY';

export const mkAccountDiscoveryDialogProps = Record({
  mode: 'ADD-FI',
  initiator: undefined,
  rootScreen: undefined,

  institutionLogin: undefined,
  mfaChallenge: undefined,

  aggAction: undefined,
  aggActionShowIntro: undefined,

  afterCloseAction: undefined,
  customDialogTitle: undefined,
  onClose: undefined,

  businessId: undefined,
});

// =============================================================================
// Account Discovery Data
// =============================================================================

export const mkDiscoveredAccount = Record({
  shadowAccountId: null,

  id: null,
  cpId: null,
  cpLoginId: null,

  channel: null,

  type: null,
  subType: null,

  name: null,
  number: null,
  maskedNumber: null,

  balance: null,
  balanceAt: null,

  currency: null,

  businessId: null,
  usageType: null,
});

export const mkActiveDiscoveredAccount = Record({
  account: accountsTypes.mkAccount('UNKNOWN'),
  discoveredAccount: mkDiscoveredAccount(),
});

export const mkAccountDiscoveryData = Record({
  institutionLoginId: null,
  credentialsBlob: null,

  status: null,

  activeAccounts: null,
  deadAccounts: null,
  newAccounts: null,
  unconnectedAccounts: null,
});

// =============================================================================
// InstitutionLoginUpserter
// =============================================================================

export const mkInstitutionLoginUpserterData = Record({
  institution: undefined,
  channel: undefined,

  institutionLogin: undefined,
  institutionLoginIdBeingMigrated: undefined,

  mfaChallenge: undefined,
  partnerAuthUris: undefined,
  publicToken: undefined,

  accountDiscoveryData: undefined,
  updateStrategy: 'UPDATE_ACCOUNTS',

  isAuthenticationDone: false,
  isAccountUpsertingDone: false,
  isAccountRefreshingDone: false,

  isPolling: false,
  isSubmitting: false,

  error: undefined,
});

export const mkInstitutionLoginUpserterStore = Record({
  upserterData: ImmutableMap(),
});

// ================================================================================================
// Types AccountDiscovery Status
// ================================================================================================

export const mkAccountDiscoveryAggregatorStatus = Record({
  isProcessing: false,

  aggStatus: 'unknown',

  cpAggStatusCode: undefined,
  cpAggStatusDetail: undefined,
  userInstructions: undefined,
});

export const mkAccountDiscoveryStatus = Record({
  institutionLoginId: null,
  isProcessing: false,
  status: '',
  aggregators: List(),
});

// ================================================================================================
// Account Upserter Types
// ================================================================================================

export const mkAccountData = Record({
  discoveredAccount: undefined,

  linkToAccountId: undefined,

  linkableAccountIdsSection1: undefined,
  linkableAccountIdsSection2: undefined,
  linkableAccountIdsSection3: undefined,

  formFieldName: undefined,
});

// ================================================================================================
// Account Discovery Error Types
// ================================================================================================

export class AccountDiscoveryFailure extends Error {
  constructor(message, aggStatus, aggStatusCode) {
    super(message);
    this.aggStatus = aggStatus;
    this.aggStatusCode = aggStatusCode;
  }
}

// ================================================================================================
// Aggregation Info Types
// ================================================================================================

export const mkFinicityAggregationInfo = Record({
  type: 'FINICITY',
  connectUrl: undefined,
  pollingRef: undefined,
});

export const mkPlaidAggregationInfo = Record({
  type: 'PLAID',
  linkToken: null,
});
